/**
 * Intro block explaining what this module does. Go into as much detail as needed,
 * the dev reading this should be able to understand what this module does
 * without having to read any code. List any plugins used.
 */


// Module options
const options = {};

// Cached elements
const $el = {
	trigger: $('.c-menu-trigger'),
	menu: $('.c-menu'),
	body: $('body')
};

// Module events
export default function init() {
    bindEvents();
};

// User interactions go here
function bindEvents() {
	$el.trigger.on('click', function(){
		$(this).toggleClass('is-active');
		$el.menu.toggleClass('is-active');
		$el.body.toggleClass('menu-is-active');
	});
};

export function resize() {

};

export function scroll() {

};

export function aria() {

};
